import type { CategoriesApi } from "@/v2/api/metadata/categories";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { notify, notifyApiError } from "@/v2/notifications";
import { NXGDSStatusVariant } from "@nsftx/seven-nxg-design-system-backoffice";

export function createDeleteDialog(options: { categoriesApi: CategoriesApi }): DialogConfig {
  const { categoriesApi } = options;

  return {
    id: "delete-category",
    title: "Delete category",
    description: `Are you sure you want to delete this category?`,
    layout: {
      type: "nxgds-dialog",
      actions: [
        { intent: "dismiss", label: "Cancel", variant: "secondary" },
        { intent: "submit", label: "Delete", variant: "danger" },
      ],
    },
    structure: {
      type: "flat",
      children: [],
    },
    api: {
      submit: async (_data, dialogCtx) => {
        try {
          await categoriesApi.delete(dialogCtx.row?.id);
          notify({
            variant: NXGDSStatusVariant.Positive,
            text: `You have successfully deleted "${dialogCtx.row?.name}" category.`,
          });
        } catch (error) {
          notifyApiError(error, `Unable to delete "${dialogCtx.row?.name}" category.`);
        }
      },
    },
  };
}
